/**
 * Formats a Date as YYYY-MM-DD using the browser's LOCAL calendar day.
 *
 * `toISOString()` converts to UTC first, so for Malaysia (UTC+8) any time between
 * midnight and 08:00 local produces the previous day. That made report date pickers
 * default to yesterday and made "today" searches return nothing.
 */
export const toLocalDateString = (value) => {
  const date = value instanceof Date ? value : new Date(value);
  if (isNaN(date)) return "";

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
};
